module.exports = __webpack_public_path__ + "static/media/whiterabbit.df079ac2.png";